/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_Status_NoneInputs */

const en_carrier_notices_status_none = /** @type {(inputs: Carrier_Notices_Status_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No notice`)
};

const es_carrier_notices_status_none = /** @type {(inputs: Carrier_Notices_Status_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin aviso`)
};

/**
* | output |
* | --- |
* | "No notice" |
*
* @param {Carrier_Notices_Status_NoneInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_status_none = /** @type {((inputs?: Carrier_Notices_Status_NoneInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_Status_NoneInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_status_none(inputs)
	return es_carrier_notices_status_none(inputs)
});